module.exports = __webpack_public_path__ + "img/1_06.4fdb91bc.jpg";